<template>
    <div class="stepper">
        <button
            class="stepper__button"
            type="button"
            :disabled="model <= 1"
            @click="model--"
        >
            &minus;
        </button>

        <label for="stepper" class="sr-only">{{ label }}</label>
        <input
            id="stepper"
            v-model="model"
            class="stepper__input"
            type="number"
            step="1"
            min="0"
            :max="max"
        >

        <button
            class="stepper__button"
            type="button"
            :disabled="isDisabled"
            @click="increment"
        >
            &plus;
        </button>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const { label, min, max } = defineProps({
    label: {
        type: String,
        required: true,
    },

    min: {
        type: Number,
        default: 1,
    },

    max: {
        type: Number,
        default: Infinity,
    },
});

const model = defineModel({
    type: Number,
    required: true,
});

function increment() {
    model.value++;
}

const isDisabled = computed(() => {
    return max <= 0;
});
</script>
